import React, { useContext, useState, useEffect } from "react";
import { auth, db } from "../../firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDocs, query, collection, where } from "firebase/firestore";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null); // Store Firestore user data
  const [userDocId, setUserDocId] = useState(null); // Store Firestore document ID
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, initializeUser);
    return unsubscribe;
  }, []);

  async function initializeUser(user) {
    if (user) {
      setCurrentUser({ ...user });
      setUserLoggedIn(true);

      try {
        console.log("Current User Object:", user);
        console.log("useremail", user.email, user.uid);
        
        const q = query(collection(db, "users"), where("workEmail", "==", user.email));
        const docSnap = await getDocs(q);
        
        if (!docSnap.empty) {
          const userDocId = docSnap.docs[0].id;  // Store document ID
          const userData = docSnap.docs[0].data();  // Get user data

          setUserDocId(userDocId);
          setUserData(userData);

          console.log("🔥 Firestore Document ID:", userDocId);
          console.log("🔥 User Data Fetched from Firestore:", userData);
        } else {
          console.log("No Firestore user data found.");
          setUserData(null);
          setUserDocId(null);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    } else {
      setCurrentUser(null);
      setUserLoggedIn(false);
      setUserData(null);
      setUserDocId(null);
    }

    setLoading(false);
  }

  const value = {
    userLoggedIn,
    currentUser,
    userData, 
    userDocId, // Provide userDocId to all components
    setCurrentUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
